import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import commonMessages from '~/containers/App/messages';
import Spacings from '~/modules/ui-kit/spacings';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';
import messages from './messages';
import styles from './styles.module.css';
import EmptyIconUrl from './empty-illustration.svg';

type ContentNotFoundProps = {
  onRetry?: () => void;
  isLoading?: boolean;
};

export const ContentNotFound = (props: ContentNotFoundProps) => {
  const theme = useTheme();
  return (
    <div className={styles.errorPage}>
      <Spacings.Inset>
        <Spacings.Stack scale="l" alignItems="center">
          <img src={EmptyIconUrl} className={styles.icon} role="presentation" />
          <Spacings.Stack alignItems="center">
            <Typography variant="h6" color="textSecondary">
              <FormattedMessage {...messages.headline} />
            </Typography>
            <Typography color="textSecondary">
              <FormattedMessage {...messages.reason} />
            </Typography>
          </Spacings.Stack>
          <Button
            variant="contained"
            color="primary"
            onClick={props.onRetry}
            startIcon={<RefreshIcon />}
            disabled={props.isLoading}
            style={{ marginTop: theme.spacing(2) }}
          >
            {props.isLoading ? (
              <FormattedMessage {...commonMessages.loading} />
            ) : (
              <FormattedMessage {...messages.retry} />
            )}
          </Button>
        </Spacings.Stack>
      </Spacings.Inset>
    </div>
  );
};

export default ContentNotFound;
